/**
 * Authentication Service
 * Handles all authentication-related API calls
 */

import request from '../utils/request';

// Use the same base URL as BOM API for authentication
// Development: http://localhost:18080
// Production: https://factory.servicetag.services.signify.com
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:18080/api';

/**
 * Initialize IDM Authentication
 * Checks if user has valid session and returns user info or login URL
 * 
 * Note: The Referer header is controlled by the browser and cannot be 
 * modified via JavaScript. If backend requires specific referrer, 
 * consider using X-Custom-Referer header instead.
 */
export const initializeAuth = async () => {
  const url = `${API_BASE_URL}/idmauth`;

  return request(url, {
    method: 'GET',
    credentials: 'include', // Include session cookies
    headers: {
      'Accept': 'application/json, text/plain, */*'
    },
  });
};
/**
 * Logout user
 * Destroys session and returns IdM logout URL
 */
// Logout user: destroys session and returns IdM logout URL
// Uses new endpoint and required headers for ServiceTag
export const logout = async () => {
  const url = API_BASE_URL + '/idmauth/logout';
  return request(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json'
    },
  });
};

export default {
  initializeAuth,
  logout,
};
